/**
 * What the device-list search box matches.
 *
 * The staff device list filters client-side (the hook fetches the customer's
 * whole fleet in one page), and that local predicate used to look at
 * `deviceName` alone — so pasting a UUID or a serial, which is how support
 * usually arrives at a device, returned nothing. The backend's own
 * `customerDevices` filter has always accepted all three
 * (`staff.service.ts` — `$or: [UUID, deviceName, serialNo]`); this brings the
 * client-side path in line with it.
 *
 * Substring rather than exact: agents paste a full UUID, but they also type
 * half a name or the tail of a serial.
 */

/** The device fields the search box reads. */
export interface SearchableDevice {
  deviceName?: string;
  UUID?: string;
  serialNo?: string;
}

/** Case-insensitive substring match over name, UUID and serial. */
export function matchesDeviceQuery(device: SearchableDevice, query: string): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  return (
    (device.deviceName ?? '').toLowerCase().includes(needle) ||
    (device.UUID ?? '').toLowerCase().includes(needle) ||
    (device.serialNo ?? '').toLowerCase().includes(needle)
  );
}
